"use server";

import { auth } from "@/lib/auth";
import { awardPoints, hasReceivedPointToday } from "@/lib/points";
import { dbg } from "@/lib/debug-log";

// Called once per mount by a client component in the root layout (see
// site-visit-tracker.tsx) — awards the daily site-visit activity point if the
// signed-in user hasn't already received one in the last rolling 24h.
// Fire-and-forget from the caller's perspective; errors are logged, not thrown,
// since a missed point should never be visible to the user as a page error.
export async function recordSiteVisit(): Promise<void> {
  const session = await auth().catch(() => null);
  if (!session?.user?.id) return;

  try {
    const already = await hasReceivedPointToday(session.user.id, "SITE_VISIT");
    if (already) return;
    await awardPoints(session.user.id, "SITE_VISIT");
  } catch (err) {
    dbg.error("kudos", "recordSiteVisit failed", { userId: session.user.id, error: String(err) });
  }
}
